import { connect } from "react-redux";
import ProductDetails from "./productDetails";
import { bindActionCreators } from "redux";
import { getProductDetails } from "services/redux/brandActivtion/products/action"

const mapStateToProps = (state) => {
  return ({
    viewProdDetails: state.productsReducer.viewProdDetails
});}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getProductDetails }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails);
